import httpClient from "../httpClient";
import httpClientPublic from "../httpClientPublic";
import { TokenService } from "../storage.service";

const END_POINT = "Account";

class AccountService {
  async login(user) {
    const params = {
      userName: user.username,
      password: user.password,
    };

    const config = {
      method: "post",
      url: `${END_POINT}/Login`,
      data: params,
    };

    const response = await httpClientPublic(config);

    if (response && response?.data) {
      const { accessToken, refreshToken } = response.data;

      if (accessToken && refreshToken) {
        TokenService.saveToken(accessToken);
        TokenService.saveRefreshToken(refreshToken);
      }
    }

    return response.data || {};
  }

  async loginThaiD() {
    const config = {
      method: "get",
      url: `${END_POINT}/loginthaid`,
    };

    const response = await httpClientPublic(config);
    window.location.href = response?.redirectUrl;
  }

  async logout() {
    const params = {
      RefreshToken: TokenService.getRefreshToken(),
    };

    const config = {
      method: "post",
      url: `${END_POINT}/Logout`,
      data: params,
    };

    const response = await httpClient(config);

    TokenService.removeToken();
    TokenService.removeRefreshToken();

    return response || {};
  }

  async refreshToken() {
    const config = {
      method: "post",
      url: `${END_POINT}/RefreshToken`,
      data: {
        RefreshToken: TokenService.getRefreshToken(),
      },
      headers: {
        Authorization: null,
      },
    };
    const response = await httpClient(config);

    if (response && response.data) {
      const { accessToken, refreshToken } = response.data;
      if (accessToken && refreshToken) {
        TokenService.saveToken(accessToken);
        TokenService.saveRefreshToken(refreshToken);
      }
    }

    return response.data;
  }

  async getAccountInfo() {
    const config = {
      method: "get",
      url: `${END_POINT}/Info`,
    };

    const response = await httpClient(config);

    return response.data || {};
  }

  async postReadCard() {
    const config = {
      method: "post",
      url: `${END_POINT}/Readcard`,
      // data: params,
    };

    const response = await httpClient(config);

    return response.data || {};
  }

  async postCallLinkageType1(params) {
    const config = {
      method: "post",
      url: `${END_POINT}/CallLinkageType1`,
      data: { ...params },
    };

    const response = await httpClient(config);

    return response || {};
  }

  async postCallLinkageType2(params) {
    const config = {
      method: "post",
      url: `${END_POINT}/CallLinkageType2`,
      data: { ...params },
    };

    const response = await httpClient(config);

    return response || {};
  }

  async postCallLinkageType3(params) {
    const config = {
      method: "post",
      url: `${END_POINT}/CallLinkageType3`,
      data: { ...params },
    };

    const response = await httpClient(config);

    return response || {};
  }

  async postCallLinkageType4(params) {
    const config = {
      method: "post",
      url: `${END_POINT}/CallLinkageType4`,
      data: { ...params },
    };

    const response = await httpClient(config);

    return response || {};
  }
}

export default new AccountService();
